﻿import { UTL } from "../util/classes";
import { PopupPlusStyleRecord, PopupPlusAuxFunctions } from "./popupPlus_Aux"; // <--- ייבוא הפונקציה הספציפית

export class AlertPlus {
    private static IS_INITIALZED: boolean = false;
    private static overlay_element: HTMLDivElement = null;
    private static popup_element: HTMLDivElement = null;
    private static caption_element: HTMLDivElement = null;
    private static text_element: HTMLDivElement = null;
    private static panel_element: HTMLDivElement = null;
    private static ok_button_element: HTMLButtonElement = null;

    public static resolve_function_pointer: Function = null; // ומשתנה זה רק שומר מצביע אליה executor_function כדי להזכיר שזאת לא פונקציה שלנו אלא פונקציה שקיבלנו מאת ה "_pointer" הוספנו את המילה
    public static par_text_str: string = "";
    //public static par_caption_exist: boolean = false;
    public static par_caption_str: string = "";
    public static par_style_rec: PopupPlusStyleRecord = null;

    private static overlay_keydown(event: KeyboardEvent): void {
        if (PopupPlusAuxFunctions.keydown_event_should_preventDefault(event) == true) {
            event.preventDefault(); // לשים את הפקודה הזאת gemini :הערה
            event.stopPropagation(); // לשים את הפקודה הזאת gemini :הערה
        }
        if (event.key === 'Tab') {
            //ליתר בטחון נעביר אליו את הפוקוס Tab יש רק כפתור. אין הרבה צורך ב
            AlertPlus.ok_button_element.focus();
        }

        if (event.key === 'Enter') {
            AlertPlus.perform_ok();
        }
        if (event.key === 'Escape') {
            AlertPlus.perform_ok();
        }
    }

    static overlay_mousedown(event: MouseEvent) {
        //---------------------------------------------------------------------------------------------
        //                               ."event.preventDefault();" שים לב. אנחנו מפעילים באירוע הזה את
        // למה? בגלל שאם לא מבצעים זאת אז לחיצה על העכבר במקום כלשהו גורמת לפוקוס לעבור למקום אחר כלשהו
        //---------------------------------------------------------------------------------------------
        event.preventDefault(); // הלך לאיבוד focus ללא השורה הזאת ה
        //AlertPlus.ok_button_element.focus();
    }

    private static perform_INITIALZE_INA() {
        const freezed_IS_INITIALZED: boolean = AlertPlus.IS_INITIALZED;
        if (freezed_IS_INITIALZED == false) {
            AlertPlus.overlay_element = document.createElement("div");;
            AlertPlus.popup_element = document.createElement("div");;
            AlertPlus.caption_element = document.createElement("div");;
            AlertPlus.text_element = document.createElement("div");;
            AlertPlus.panel_element = document.createElement("div");;
            AlertPlus.ok_button_element = document.createElement("button");;
            //-----------------------------
            AlertPlus.overlay_element.appendChild(AlertPlus.popup_element);
            AlertPlus.popup_element.appendChild(AlertPlus.caption_element);
            AlertPlus.popup_element.appendChild(AlertPlus.text_element);
            AlertPlus.popup_element.appendChild(AlertPlus.panel_element);
            AlertPlus.panel_element.appendChild(AlertPlus.ok_button_element);
            //-----------------------------
            AlertPlus.ok_button_element.addEventListener("click", AlertPlus.perform_ok);
            AlertPlus.overlay_element.addEventListener("keydown", AlertPlus.overlay_keydown);
            AlertPlus.overlay_element.addEventListener("mousedown", AlertPlus.overlay_mousedown);
            //-----------------------------

            AlertPlus.IS_INITIALZED = true;
        }
    }

    private static perform_ok(): void {
        //UTL.show_which_element_has_focus();

        document.body.removeChild(AlertPlus.overlay_element);
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        AlertPlus.resolve_function_pointer();
        AlertPlus.resolve_function_pointer = null; // כדי שלא נקרא בפעם אחרת בטעות לפונקציה ישנה  
    }

    public static prepare(): void {
        AlertPlus.perform_INITIALZE_INA();

        if (true) {

            PopupPlusAuxFunctions.apply_style_to_overlay_element(AlertPlus.overlay_element, AlertPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_popup_element(AlertPlus.popup_element, AlertPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_caption_element(AlertPlus.caption_element, AlertPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_text_element(AlertPlus.text_element, AlertPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_panel_element(AlertPlus.panel_element, AlertPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_ok_button_element(AlertPlus.ok_button_element, AlertPlus.par_style_rec);
        }

        if (true) {
            if (AlertPlus.par_caption_str == null) {
                AlertPlus.caption_element.style.display = "none";
            }
            if (AlertPlus.par_caption_str != null) {
                AlertPlus.caption_element.style.display = "block";
            }
        }
        if (true) {
            AlertPlus.caption_element.innerText = AlertPlus.par_caption_str;
            //AlertPlus.text_element.innerText = AlertPlus.par_text_str;
            AlertPlus.text_element.innerHTML = AlertPlus.par_text_str; //innerHTML ל innerText שינינו מ
            //AlertPlus.text_element.style.fontSize = AlertPlus.par_style_rec.text_element_fontSize;
        }

    }

    public static executor_function(p_resolve: Function, p_reject: Function): void {
        //debugger;
        AlertPlus.resolve_function_pointer = p_resolve;
        AlertPlus.prepare();
        document.body.appendChild(AlertPlus.overlay_element);
        UTL.center_popup_element_inside_overlay_element(AlertPlus.popup_element, AlertPlus.overlay_element);
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        AlertPlus.ok_button_element.focus();
    }


    public static ShowAsync(p_text_str: string, p_caption_str: string = null, p_style_rec: PopupPlusStyleRecord = null): Promise<void> {
        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה
        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה

        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה

        if (p_style_rec != null && (p_style_rec instanceof PopupPlusStyleRecord) == false) {
            alert("AlertPlus.p_style_rec is not PopupPlusStyleRecord");
            return;
        }
        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        AlertPlus.par_text_str = p_text_str;
        AlertPlus.par_caption_str = p_caption_str;
        AlertPlus.par_style_rec = p_style_rec;
        if (AlertPlus.par_style_rec == null) {
            AlertPlus.par_style_rec = PopupPlusAuxFunctions.create_rec_style_v1("ltr", "20px", false);
        }
        return new Promise(AlertPlus.executor_function);
    }
}
